import { css } from 'lit';

export default css`
  :host {
    --speed: var(--syn-transition-x-slow);
    --indicator-color: var(--syn-interactive-emphasis-color);
  }

  .spinner__indicator {
    stroke-dasharray: 75% 360%;
    stroke-linecap: initial;
  }

  /**
   * Make sure the spinner track is using the correct color.
   */
  .spinner__track {
    filter: saturate(0);
    opacity: var(--syn-spinner-opacity);
    stroke: var(--indicator-color);
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;
